<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @cancel="handleCancel"
    :fullscreen="true"
    cancelText="关闭">

    <template slot="footer">
      <a-button key="cancel" @click="handleCancel">关闭</a-button>
      <a-button v-if="!disableSubmit" key="submit" @click="handleOk" type="primary" :loading="confirmLoading">提交
      </a-button>
      <a-button v-if="!disableSubmit" key="publish" type="primary" @click="handleCancel">保存并发布</a-button>
    </template>

    <a-spin :spinning="confirmLoading">
      <!-- 主表单区域 -->
      <a-form :form="form">
        <a-row>
          <a-card class="card" title="商品信息" :bordered="false">
            <a-col :xs="24" :sm="12">
              <a-form-item label="商品popoup" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-popup placeholder="请输入发布编号" v-decorator="['productInfo', validatorRules.productInfo]"
                         :trigger-change="true" code="manufacture-product"
                         org-fields="prod_name,prod_specs,prod_type,prod_pic,prod_props,id"
                         dest-fields="productInfo,prodSpec,prodType,prodPic,publishProdProps,prodId"
                         @callback="popupCallback"
                         field="productInfo"
                         :disabled="readOnly || model.publishState == 'publish_success'"
                ></j-popup>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12">
              <a-form-item label="商品品类" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-dict-select-tag v-decorator="['prodType',validatorRules.prodType]"
                                   :trigger-change="true" placeholder="请选择商品品类"
                                   dict-code="manufacture_product_category,name,id,is_enabled=1"
                                   disabled></j-dict-select-tag>
              </a-form-item>
            </a-col>
          </a-card>
          <a-card class="card" title="发布信息" :bordered="false">
            <a-col :xs="24" :sm="12">
              <a-form-item label="发布编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input disabled v-decorator="['publishCode']" placeholder="请输入发布编号"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12">
              <a-form-item label="商品发布名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['publishProdName', validatorRules.publishProdName]" placeholder="请输入商品发布名称"
                         :disabled="readOnly"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12">
              <a-form-item label="商品规格" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-dict-select-tag type="list" v-decorator="['prodSpec', validatorRules.prodSpecs]"
                                   :trigger-change="true" placeholder="请选择商品规格"
                                   dict-code="manufacture_product_specs,spec_name,id" :disabled="readOnly"/>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12">
              <a-form-item label="商品属性" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-multi-select-tag type="list_multi" v-decorator="['prodProp', validatorRules.prodProps]"
                                    :trigger-change="true" placeholder="请选择商品属性"
                                    dict-code="manufacture_product_props,prop_name,id" :disabled="readOnly"
                                    ref="prodProps"/>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12">
              <a-form-item label="商品发布简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-textarea v-decorator="['publishProdDescription', validatorRules.publishProdDescription]" rows="4"
                            placeholder="请输入商品发布简介" :disabled="readOnly"/>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12">
              <a-form-item label="商品发布图片" :labelCol="labelCol" :wrapperCol="wrapperCol" help="至少上传1张图片，且最多不超过3张">
                <j-image-upload ref="proPicComp"
                                isMultiple v-decorator="['publishPic',validatorRules.publishPic]"
                                :disabled="readOnly"
                                @change="handleProPicChange($event)"></j-image-upload>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12">
              <a-form-item label="所属门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-dict-select-tag ref="publishProdStoreComp" type="list"
                                   v-decorator="['storeId', validatorRules.storeId]"
                                   :trigger-change="true" :dictParam="storeDictCode"
                                   placeholder="请选择所属门店"
                                   :disabled="readOnly || model.publishState == 'publish_success'"/>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12">
              <a-form-item label="是否可配送" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-dict-select-tag type="list" v-decorator="['publishIsdelivery', validatorRules.publishIsdelivery]"
                                   :trigger-change="true" dictCode="yesorno" placeholder="请选择是否可配送"
                                   :disabled="readOnly"/>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12">
              <a-form-item label="发布渠道" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-multi-select-tag ref="publishChannelComp" type="list_multi"
                                    v-decorator="['publishChannel', validatorRules.publishChannel]"
                                    :trigger-change="true" :dictParam="channelDictCode"
                                    placeholder="请选择发布渠道"
                                    :disabled="readOnly || model.publishState == 'publish_success'"/>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12">
              <a-form-item label="发布状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-dict-select-tag type="list" v-decorator="['publishState', validatorRules.publishState]"
                                   :trigger-change="true" disabled dictCode="s_publish_state" placeholder="请选择发布状态"/>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12">
              <a-form-item label="在架状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-dict-select-tag type="list" v-decorator="['publishSaleState']"
                                   :trigger-change="true" disabled dictCode="s_publish_sale_state"
                                   placeholder="请选择发布状态"/>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12">
              <a-form-item label="发布时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-date disabled placeholder="请选择发布时间" v-decorator="['publishTime']" :trigger-change="true"
                        date-format="YYYY-MM-DD HH:mm:ss" style="width: 100%"/>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12">
              <a-form-item label="商品id" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input disabled placeholder="请选择商品id" v-decorator="['prodId']" :trigger-change="true"
                         style="width: 100%"/>
              </a-form-item>
            </a-col>
          </a-card>

        </a-row>
      </a-form>

      <!-- 子表单区域 -->
      <a-tabs v-model="activeKey" @change="handleChangeTabs">
        <a-tab-pane ref="publishPriceTableTab" tab="商品发布规格" :key="refKeys[0]" :forceRender="true">
          <a-alert v-if="showErrorForPriceTable" type="error" showIcon message="至少需要添加两个规格！"/>
          <j-editable-table
            :ref="refKeys[0]"
            :loading="publishPriceTable.loading"
            :columns="publishPriceTable.columns"
            :dataSource="publishPriceTable.dataSource"
            :maxHeight="300"
            :rowNumber="true"
            :rowSelection="true"
            :actionButton="!readOnly"
            v-if="showPriceTable"
          />
        </a-tab-pane>
        <a-tab-pane tab="商品属性设置" :key="refKeys[2]" :forceRender="true">
          <a-button v-if="!readOnly" type="primary" @click="addPublishPropListItem">新增</a-button>
          <a-list item-layout="horizontal">
            <a-list-item v-for="(item,index) in publishPropData" :key="index">
              <template>
                <a-select :ref="'pn_'+index" :value="item.propId" @change="handlePropNameChange($event,index)"
                          style="width:20%" placeholder="请选择商品属性" :disabled="readOnly">
                  <a-select-option :value="undefined">请选择</a-select-option>
                  <a-select-option v-for="(option, oindex) in publishPropOptions" :key="oindex" :value="option.value">
                    <span style="display: inline-block;width: 100%" :title=" option.text || option.label ">
                      {{ option.text || option.label }}
                    </span>
                  </a-select-option>
                </a-select>
                <a-select style="width:80%" :ref="'pv_'+index" :value="item.propValues" mode="tags" placeholder="请输入属性值"
                          @change="handlePublishPropValueChange($event,index)" :disabled="readOnly"></a-select>
              </template>
              <div v-if="!readOnly || model.publishState == 'publish_success'" slot="actions">
                <a @click="handleDeletePublishPropListItem(item,index)">删除</a>
              </div>
            </a-list-item>
          </a-list>
        </a-tab-pane>
        <a-tab-pane tab="商品发布关联渠道商品" :key="refKeys[1]" :forceRender="true">
          <j-editable-table
            :ref="refKeys[1]"
            :loading="salesPublishOnlineidTable.loading"
            :columns="salesPublishOnlineidTable.columns"
            :dataSource="salesPublishOnlineidTable.dataSource"
            :maxHeight="300"
            :rowNumber="true"
            :rowSelection="true"
            :actionButton="false"/>
        </a-tab-pane>
      </a-tabs>

    </a-spin>
  </j-modal>
</template>

<script>

import {getAction, httpAction, putAction} from '@/api/manage'
import pick from 'lodash.pick'
import {validateDuplicateValue, arrayToDictOptions, randomUUID} from '@/utils/util'
import JDate from '@/components/jeecg/JDate'
import {FormTypes, getRefPromise, validateFormAndTables} from '@/utils/JEditableTableUtil'
import {JEditableTableMixin} from '@/mixins/JEditableTableMixin'
import JDictSelectTag from "@/components/dict/JDictSelectTag"
import JMultiSelectTag from "@/components/dict/JMultiSelectTag"
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import {ajaxGetDictItems, getDictItemsFromCache} from '@/api/api'
import {initDictOptions} from '@/components/dict/JDictSelectUtil'
import JImageUpload from '@/components/jeecg/JImageUpload'
import JTreeSelect from "@/components/jeecg/JTreeSelect"


export default {
  name: 'SalesPublishListModal',
  mixins: [JEditableTableMixin],
  components: {
    JDate,
    JDictSelectTag,
    JMultiSelectTag,
    JSearchSelectTag,
    JTreeSelect,
    JImageUpload
  },
  data() {
    return {
      action: '',
      disableSubmit: false,
      publishPropOptions: [],
      publishPropValueOptions: [],
      storeDictCode: "sales_physical_store,phystore_name,id",
      channelDictCode: "sales_channel,channel_name,id",
      publishPropData: [],
      propDict: 'manufacture_product_category,name,id',
      propCondition: '{"is_enabled":1,"is_type":"prop_key,prop_value"}',
      showErrorForPriceTable: false,
      propPidValue: '',
      proPicMaxUpload: 1,
      title: "操作",
      showPriceTable: true,
      showPropTable: true,
      width: 1200,
      visible: false,
      model: {
        prodSpec: "",
      },
      labelCol: {
        xs: {span: 24},
        sm: {span: 6},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
      labelCol2: {
        xs: {span: 24},
        sm: {span: 3},
      },
      wrapperCol2: {
        xs: {span: 24},
        sm: {span: 20},
      },
      confirmLoading: false,
      // 新增时子表默认添加几行空数据
      addDefaultRowNum: 1,
      validatorRules: {
        productInfo: {
          rules: [
            {required: true, message: '请输入商品信息!'},
          ]
        },
        publishProdName: {
          rules: [
            {required: true, message: '请输入商品发布名称!'},
          ]
        },
        publishProdDescription: {
          rules: [
            {required: true, message: '请输入商品发布简介!'},
          ]
        },
        storeId: {
          rules: [
            {required: true, message: '请输入所属门店!'},
          ]
        },
        publishIsdelivery: {
          rules: [
            {required: true, message: '请输入是否可配送!'},
          ]
        },
        publishChannel: {
          rules: [
            {required: true, message: '请输入发布渠道!'},
          ]
        },
        publishState: {
          rules: [
            {required: true, message: '请输入发布状态!'},
          ]
        }
      },
      refKeys: ['publishPrice', 'salesPublishOnlineid', 'salesPublishProps'],
      tableKeys: ['publishPrice', 'salesPublishOnlineid',],
      activeKey: 'publishPrice',
      publishPriceTable: {
        loading: false,
        dataSource: [],
        columns: [
          {
            title: '商品规格',
            key: 'prodSpecs',
            type: FormTypes.select,
            dictCode: "",
            width: "200px",
            placeholder: '请选择${title}',
            defaultValue: '',
            options: [],
            validateRules: [{required: true, message: '${title}不能为空'}],
            disabled: false
          },
          {
            title: '单价',
            key: 'price',
            type: FormTypes.inputNumber,
            width: "200px",
            placeholder: '请输入${title}',
            defaultValue: '',
            validateRules: [{required: true, message: '${title}不能为空'}],
            disabled: false
          },
          {
            title: '销售库存',
            key: 'saleStock',
            type: FormTypes.inputNumber,
            width: "200px",
            placeholder: '请输入${title}',
            defaultValue: '',
            validateRules: [{
              required: true,
              message: '${title}不能为空',
              handler(type, value, row, column, callback, target) {
                let {values} = target.getValuesSync({validate: false, rowIds: [row.id]})
                let rowData = values[0]
                if (rowData.maxStock && value > rowData.maxStock) {
                  callback(false, "销售库存不能超过最大库存！")
                } else {
                  callback(true)
                }
              }
            }],
            disabled: false
          },
          {
            title: '最大库存',
            key: 'maxStock',
            type: FormTypes.inputNumber,
            width: "200px",
            placeholder: '请输入${title}',
            defaultValue: '',
            validateRules: [{
              required: true,
              message: '${title}不能为空',
              handler(type, value, row, column, callback, target) {
                let {values} = target.getValuesSync({validate: false, rowIds: [row.id]})
                let rowData = values[0]
                if (rowData.saleStock && value < rowData.saleStock) {
                  callback(false, "销售库存不能超过最大库存！")
                } else {
                  callback(true)
                }
              }
            }],
            disabled: false
          },
          {
            title: '饿了么规格id',
            key: 'elemeSpecId',
            type: FormTypes.input,
            width: "200px",
            placeholder: '请输入${title}',
            defaultValue: '',
            validateRules: [],
            disabled: true
          },
          {
            title: '美团规格id',
            key: 'mtuanSpecId',
            type: FormTypes.input,
            width: "200px",
            placeholder: '请输入${title}',
            defaultValue: '',
            validateRules: [],
            disabled: true
          },
          {
            title: 'pid',
            key: 'pid',
            type: FormTypes.input,
            width: "200px",
            placeholder: '请输入${title}',
            defaultValue: '',
            validateRules: [],
            disabled: true
          },
          {
            title: 'cid',
            key: 'cid',
            type: FormTypes.input,
            width: "200px",
            placeholder: '请输入${title}',
            defaultValue: '',
            validateRules: [],
            disabled: true
          },
        ]
      },
      // 商品发布关联渠道商品
      salesPublishOnlineidTable: {
        loading: false,
        dataSource: [],
        columns: [
          {
            title: '渠道商品id',
            key: 'channelProdId',
            type: FormTypes.input,
            width: "200px",
            placeholder: '请输入${title}',
            defaultValue: '',
            disabled: true
          },
          {
            title: '渠道编码',
            key: 'channelCode',
            type: FormTypes.input,
            width: "200px",
            placeholder: '请输入${title}',
            defaultValue: '',
            disabled: true
          },
          {
            title: '渠道店铺id',
            key: 'channelStoreId',
            type: FormTypes.input,
            width: "200px",
            placeholder: '请输入${title}',
            defaultValue: '',
            disabled: true
          },
        ]
      },
      url: {
        add: "/sales/salesPublishList/add",
        edit: "/sales/salesPublishList/edit",
        queryProdById: "/manufacture/manufactureProduct/queryById",
        querySpecValueById: "/manufacture/manufactureProductSpecs/queryById",
        queryPropValueById: "/manufacture/manufactureProductProps/queryById",
        queryTypeInfoByTypeId: "/manufacture/manufactureProductCategory/queryById",
        salesPublishOnlineid: {
          list: '/sales/salesPublishList/querySalesPublishOnlineidByMainId'
        },
      }
    }
  },
  computed: {
    readOnly: function () {
      return this.action !== "add" && this.action !== "edit"
    }
  },
  methods: {
    add() {
      const that = this
      this.action = 'add'
      // 生成发布编号
      const url = '/sys/fillRule/executeRuleByCode/'
      const ruleCode = 'prod_publish_no'
      putAction(url + ruleCode, {}).then(res => {
        if (res.success) {
          that.$nextTick(() => {
            that.form.setFieldsValue({'publishCode': res.result})
          })
        }
      })
      this.edit({})
      // 设置发布状态默认值
      this.$nextTick(() => {
        this.form.setFieldsValue({'publishState': 'un_publish', 'publishSaleState': 'off_shelves'})
      })
    },
    copy(record) {
      this.resetForm()
      this.add()
      this.edit(record)
    },
    resetForm() {
      this.form.resetFields();
      this.publishPriceTable.dataSource = []
      this.publishPriceTable.columns[0].options = []
      this.publishPropData = []
      this.publishPropOptions = []
      this.salesPublishOnlineidTable.dataSource = []
      this.showErrorForPriceTable = false
      this.activeKey = this.refKeys[0]
    },
    edit(record) {
      this.resetForm()
      this.model = Object.assign({}, record)
      this.visible = true;
      let fieldval = pick(this.model, 'publishCode', 'productInfo', 'publishProdName', 'publishProdDescription', 'storeId', 'publishIsdelivery', 'publishChannel', 'publishState', 'publishTime', 'publishProdStock', 'prodProp', 'prodSpec', 'prodType', 'publishPic', 'prodId', 'publishSaleState')
      this.$nextTick(() => {
        this.form.setFieldsValue(fieldval)
        this.handleProdInfoChange(this.model)
        if (this.model.publishProdSpecs) {
          this.publishPriceTable.dataSource = JSON.parse(this.model.publishProdSpecs)
        }
        if (this.model.publishProdProps) {
          this.publishPropOptions = this.$refs.prodProps.$data.dictOptions
          this.publishPropData = JSON.parse(this.model.publishProdProps)
        }
      })
      // 加载子表数据
      if (this.model.id) {
        let params = {id: this.model.id}
        this.requestSubTableData(this.url.salesPublishOnlineid.list, params, this.salesPublishOnlineidTable)
      }
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      if (that.$refs[that.refKeys[0]].$data.rows.length < 2) {
        that.showErrorForPriceTable = true
        return
      }
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'put';
          }
          console.log(that.$refs[that.refKeys[0]].$data.rows.length)
          // 获取定价列表数据，组装为json赋值给publishPrice
          that.getAllTable().then(tables => {
            that.model.publishProdProps = JSON.stringify(this.publishPropData)
            return validateFormAndTables(that.form, tables)
          }).then(allValues => {
            if (typeof this.classifyIntoFormData !== 'function') {
              throw this.throwNotFunction('classifyIntoFormData')
            }
            let formData = this.classifyIntoFormData(allValues)
            console.log("表单提交数据", formData)
            this.confirmLoading = true
            httpAction(httpurl, formData, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          })
        }
      })
    },
    handleProdInfoChange(record) {
      let that = this
      if (!record.prodSpec) {
        return
      }
      // 联动渠道和门店
      getAction(this.url.queryTypeInfoByTypeId, {id: record.prodType}).then(res => {
        if (res.success && res.result) {
          let prodTypeInfo = res.result
          if (prodTypeInfo.typeStore) {
            let typeStoreConditionArray = prodTypeInfo.typeStore.split(",")
            let typeStoreCondition = ""
            typeStoreConditionArray.forEach((item, index, arr) => {
              if (arr.length == 1) {
                typeStoreCondition = "id=" + item
              } else if (index == (arr.length - 1)) {
                typeStoreCondition += "id=" + item
              } else {
                typeStoreCondition += "id=" + item + " or "
              }
            })
            that.$refs.publishProdStoreComp.dictParam = "sales_physical_store,phystore_name,id," + typeStoreCondition
          }
          if (prodTypeInfo.typeChannel) {
            let typeChannelConditionArray = prodTypeInfo.typeChannel.split(",")
            let typeChannelCondition = ""
            typeChannelConditionArray.forEach((item, index, arr) => {
              if (arr.length == 1) {
                typeChannelCondition = "id=" + item
              } else if (index == (arr.length - 1)) {
                typeChannelCondition += "id=" + item
              } else {
                typeChannelCondition += "id=" + item + " or "
              }
            })
            that.$refs.publishChannelComp.dictParam = "sales_channel,channel_name,id," + typeChannelCondition
          }
        }
      })
      // 联动规格
      getAction(this.url.querySpecValueById, {id: record.prodSpec}).then(res => {
        if (res.success && res.result) {
          let resultArray = JSON.parse(res.result.specValue)
          if (resultArray.length > 0) {
            that.showPriceTable = false
            that.publishPriceTable.columns[0].options = arrayToDictOptions(resultArray)
            that.publishPropOptions = that.$refs.prodProps.$data.dictOptions
            that.$nextTick(() => {
              that.showPriceTable = true
            })
          }
        }
      })
    },
    addPublishPropListItem() {
      this.publishPropData.push({propId: undefined, propName: undefined, propValues: []})
      this.$nextTick(() => {
        this.publishPropOptions = this.$refs.prodProps.$data.dictOptions
      })
    },
    getAllTable() {
      let values = this.tableKeys.map(key => getRefPromise(this, key))
      return Promise.all(values)
    },
    handleCancel() {
      this.close()
    },
    /** 整理成formData */
    classifyIntoFormData(allValues) {
      let main = Object.assign(this.model, allValues.formValue)
      return {
        ...main, // 展开
        salesPublishOnlineidList: allValues.tablesValue[1].values,
        publishProdSpecs: JSON.stringify(allValues.tablesValue[0].values)
      }
    },
    validateError(msg) {
      this.$message.error(msg)
    },
    popupCallback(row) {
      this.form.setFieldsValue(pick(row, 'publishCode', 'productInfo', 'publishProdName', 'publishProdDescription', 'storeId', 'publishIsdelivery', 'publishChannel', 'publishState', 'publishTime', 'publishProdStock', 'publishProdSpecs', 'prodProp', 'prodType', 'prodSpec', 'publishPic', 'prodId', 'publishSaleState'))
      this.handleProdInfoChange(row)
    },
    handleProPicChange(event) {
      if (event) {
        let picArray = event.split(',')
        if (picArray.length >= this.$data.proPicMaxUpload) {
          this.$refs.proPicComp.$children[0].$children[1].disabled = true
        }
      }
    },
    handlePropNameChange(event, index) {
      let that = this
      getAction(this.url.queryPropValueById, {id: event}).then(res => {
        if (res.success && res.result) {
          let resultArray = JSON.parse(res.result.propValue)
          if (resultArray.length > 0) {
            that.publishPropData[index].propId = event
            that.publishPropOptions.forEach(item => {
              if (item.value == event) {
                that.publishPropData[index].propName = item.text
                return
              }
            })
            that.publishPropData[index].propValues = resultArray
          }
        }
      })
    },
    handlePublishPropValueChange(value, index) {
      this.publishPropData[index].propValues = value
    },
    handleDeletePublishPropListItem(listItem, index) {
      this.publishPropData.splice(index, 1)
    }
  }
}
</script>

<style scoped>
</style>